<template>
	<div :class="classEyedis">
		<HeaderApp :eyedis="eyedis" :setEyedis="setEyedisField" :ipData="ipData" :key="ipData.ip" :routes="routes"/>
		<div class="page-body">
			<ContentApp :routes="routes" :ipData="ipData" :key="ipData.ip" />
			<FooterApp :setEyedis="setEyedisField" :eyedis="eyedis"/>
		</div>
	</div>
</template>

<script>
import HeaderApp from '@/components/HeaderApp.vue'
import ContentApp from '@/components/ContentApp.vue'
import FooterApp from '@/components/FooterApp.vue'
import routes from "./router/routes"
import { getDataJson } from '@/api/getData'
import { getConfig, } from '@/auth';

export default {
	name: 'App',
	components: {
		HeaderApp,
		ContentApp,
		FooterApp
	},
	data() {
		return {
			routes,
			eyedis: {
				print: false,
				fonts: 'second',
				colors: 'first',
				images: false,
			},
			ipData: {
				ip: null,
				has_security: null,
			}
		}
	},
	created() {
		let eyedis = localStorage.getItem('eyedis') 
		if (eyedis) {
			this.eyedis = JSON.parse(eyedis)
		}

		let urlIp = getConfig().apiIPFirst
		
		getDataJson(urlIp)
			.then(data => {
				this.ipData = data.data
			})
			.catch(err => {
				console.log(err)
				urlIp = getConfig().apiIP

				getDataJson(urlIp)
					.then(data => {
						this.ipData = data.data
					})
					.catch(err => {
						console.log(err)
					})
			})
	},
	methods: {
		setEyedisField: function(field, value) {
			let eyedis = this.eyedis
			eyedis[field] = value
			this.eyedis = {...eyedis}
			localStorage.setItem('eyedis', JSON.stringify(eyedis))
		}
	},
	computed: {
		classEyedis: function () {
			let eyedis = this.eyedis
			let obj = { eyedis: eyedis.print,}
			obj[`eyedis-colors__${eyedis.colors}`] = true
			obj[`eyedis-fonts__${eyedis.fonts}`] = true
			obj[`eyedis__${eyedis.images ? 'img-on' : 'img-off'}`] = true
			
			return obj
		}
	}
}
</script>

